const initialState = {
  modal: false,
  route: null,
  camera_id: null,
  updated: false,
  deleted: false,
  is_tadbir: false,
  district_id: null
}

const operativeModal = (state = initialState, action) => {
  switch (action.type) {
    case "MODAL_ACTION":
      return { ...state, modal: action.val.modal, route: action.val.route, camera_id: action.val.camera_id, is_tadbir: action.val.is_tadbir, object: action.val.object }
    case "OPERATIVE_UPDATE_DATA":
      return { ...state, updated: action.val }
    case "OPERATIVE_DELETED_DATA":
      return { ...state, deleted: action.val }
    default:
      return state
  }
}

export default operativeModal
